<template>
  <Signup type="Shop" />
</template>

<script>
import Signup from "@/components/auth/Signup.vue";

export default {
  components: {
    Signup
  }
};
</script>

<style>
</style>
